import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import { WORKER_KEYS } from './useWorkerProfile';

interface SubmitPayload {
    assignmentId: string;
    result: Record<string, unknown>;
    proof_url?: string;
}

export const useSubmitAssignment = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ assignmentId, result, proof_url }: SubmitPayload) => {
            const { data } = await api.post(
                API_ROUTES.workerSubmitAssignment(assignmentId),
                { result, proof_url: proof_url || '' }
            );
            return data;
        },
        onSuccess: (_data, variables) => {
            toast.success('Trabajo enviado exitosamente');
            queryClient.invalidateQueries({ queryKey: WORKER_KEYS.assignment(variables.assignmentId) });
            queryClient.invalidateQueries({ queryKey: ['worker', 'assignments'] });
        },
        onError: (error: any) => {
            const detail = error?.response?.data?.detail || 'Error al enviar el trabajo';
            toast.error(detail);
        },
    });
};
